export const BACKEND_API = "https://cpweather-backend.onrender.com";
export const CLOUDINARY_URL = "https://res.cloudinary.com/doj90b0q7/image/upload/v1688378993/CPWEATHER/statics";
export const UPLOAD = "https://res.cloudinary.com/doj90b0q7/image/upload/v1688378993/CPWEATHER";
// export const BACKEND_API = "https://cpweather-backend.onrender.com";